interface AccountRoles {isSales?:boolean;isAccounting?:boolean;isOP?:boolean;isAdmin?:boolean;isAffiliate?:boolean;isTenantMember?:boolean;adminHome?:string}
export function loginFormErrors(loginId:string,password:string):Record<string,string> {
  const errors:Record<string,string>={}
  if(!loginId.trim())errors.loginId='請輸入登入帳號'
  else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(loginId.trim()))errors.loginId='請輸入有效的電子信箱'
  if(!password)errors.password='請輸入密碼'
  return errors
}
export function accountHomePath(user:AccountRoles):string {
  if(user.isAdmin && user.adminHome)return user.adminHome
  if(user.isSales)return '/admin/contacts'
  if(user.isAccounting)return '/admin/payouts'
  if(user.isOP)return '/admin/products'
  if(user.isAdmin)return '/admin/affiliates'
  if(user.isAffiliate)return '/affiliate/dashboard'
  if(user.isTenantMember)return '/agency/dashboard'
  return '/login'
}
export function safeLoginDestination(value:unknown,fallback:string):string {
  if(typeof value!=='string'||!value.startsWith('/'))return fallback
  try {
    const decoded=decodeURIComponent(value)
    if(!/^\/(?!\/)/.test(decoded)||/[\\\u0000-\u001f\u007f]/.test(decoded))return fallback
    const url=new URL(decoded,'https://local.invalid')
    if(url.origin!=='https://local.invalid'||/^\/(?:login|forgot-password|reset-password|change-password)(?:\/|$)/.test(url.pathname)||url.searchParams.has('oobCode'))return fallback
    return value
  } catch {return fallback}
}
